import { render, staticRenderFns } from "./Specialists.vue?vue&type=template&id=6ad320fe&scoped=true&"
import script from "./Specialists.vue?vue&type=script&lang=ts&"
export * from "./Specialists.vue?vue&type=script&lang=ts&"
import style0 from "./Specialists.vue?vue&type=style&index=0&id=6ad320fe&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ad320fe",
  null
  
)

export default component.exports